import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "../../components/shared/SectionHeading";
import { EmptyState } from "../../components/shared/EmptyState";
import { api } from "../../lib/api";
import { usePageMedia } from "../../lib/usePageMedia";
import { usePageTexts } from "../../lib/usePageTexts";

export default function BlogPage() {
  const [posts, setPosts] = useState(null);
  const pageMedia = usePageMedia();
  const { text } = usePageTexts();
  const hero = pageMedia["blog:hero"];
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);
  const shown = posts || [];

  return (
    <div className="container-ae py-12 md:py-16" data-testid="blog-page">
      <SectionHeading overline="Blog & Conseils" title="Idées et conseils" accent="pour votre événement">
        {text("blog:intro", "Conseils, inspirations et coulisses pour préparer votre événement.")}
      </SectionHeading>
      {hero && (
        <img src={hero.url} alt={hero.alt || "Blog Art Event"} className="mb-10 aspect-[21/9] w-full rounded-xl object-cover" data-testid="page-hero-image" />
      )}
      {posts && shown.length === 0 && (
        <div className="mt-10"><EmptyState title="Bientôt disponible">Les premiers articles sont en préparation — revenez très vite.</EmptyState></div>
      )}
      <div className="mt-10 grid gap-8 md:grid-cols-2">
        {shown.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="group card-ae overflow-hidden transition-transform duration-300 hover:-translate-y-1">
            {post.image && <img src={post.image} alt={post.title} loading="lazy" className="aspect-[16/9] w-full object-cover" />}
            <div className="p-6">
              <p className="overline-ae">{post.category}</p>
              <h3 className="mt-2 font-heading text-2xl text-deepgreen">{post.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{post.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-deepgreen">
                Lire l'article <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
